import { FC, memo, ReactNode } from 'react'
import styles from './index.module.scss'

interface ButtonProps {
  text: string
  icon: ReactNode
  onClick: () => void
}

const WalletButton: FC<ButtonProps> = ({ text, icon, onClick }) => {
  return (
    <>
      <div className={styles.container} onClick={onClick}>
        {icon}
        {text}
      </div>
    </>
  )
}

export default memo(WalletButton)
